<template>
	<div>
		<div class="modal fade" id="modalConsultaProducto" role="dialog" aria-labelledby="moda-producto-label" aria-hidden="true">
			<div class="modal-dialog modal-dialog-scrollable" role="document">
			    <div class="modal-content">
			      	<div class="modal-header">
			        	<h5 class="modal-title" id="moda-producto-label">
			        		{{form.codigo}} | {{form.descripcion}}
			        	</h5>
			        	<div class="btn-group">
					        <button type="button" class="btn btn-link" v-on:click="getProducto()">
					        	<i class="material-icons">refresh</i>
					        </button>
				        	<button type="button" class="btn btn-link" data-dismiss="modal" aria-label="Close">
					        	<i class="material-icons">close</i>
					        </button>
			        	</div>
			    	</div>
			    	<preloader v-if="loading"></preloader>
			    	<div class="modal-body py-0">
			    		<ul class="nav nav-tabs" id="ConsultaProductos" role="tablist">
							<li class="nav-item">
						    	<a class="nav-link active" id="informacion-producto-tab" data-toggle="tab" href="#informacion-producto" role="tab" aria-controls="informacion-producto" aria-selected="true">
						    		Información
						    	</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" id="auditoria-producto-tab" data-toggle="tab" href="#auditoria-producto" role="tab" aria-controls="auditoria-producto" aria-selected="false">
									Auditoría
								</a>
							</li>
						</ul>
						<div class="tab-content" id="ConsultaProductosContent">
							<div class="tab-pane fade show active" id="informacion-producto" role="tabpanel" aria-labelledby="informacion-producto-tab">
								<div class="row py-3">
									<div class="col-md-12 mb-3">
										<div class="media">
											<div class="align-self-center mr-3" title="Grupo del Producto">
												<i class="material-icons">shop</i>
											</div>
											<div class="media-body">
												<label>Grupo del Producto:</label>
												<p class="m-0">
													{{form.grupo.codigo}} - {{form.grupo.descripcion}}
												</p>
											</div>
										</div>
									</div>

									<div class="col-md-12 mb-3">
										<div class="media">
											<div class="align-self-center mr-3" title="Sub Grupo del Producto">
												<i class="material-icons">shop_two</i>
											</div>
											<div class="media-body">
												<label>Sub Grupo del Producto:</label>
												<p class="m-0">
													{{form.subgrupo.codigo}} - {{form.subgrupo.descripcion}}
												</p>
											</div>
										</div>
									</div>

									<div class="col-md-12 mb-3">
										<div class="media">
											<div class="align-self-center mr-3" title="Precio">
												<i class="material-icons">local_atm</i>
											</div>
											<div class="media-body">
												<label>Precio:</label>
												<p class="m-0">
													{{form.precio}}
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="tab-pane fade" id="auditoria-producto" role="tabpanel" aria-labelledby="auditoria-producto-tab">
								<div class="row py-3">
									<div class="col-md-6 mb-3">
										<div class="media">
											<div class="align-self-center mr-3" title="Creado Por">
												<i class="material-icons">person_add</i>
											</div>
											<div class="media-body">
												<label>Creado Por:</label>
												<p class="m-0">
													{{form.creado_por.codigo}} - {{form.creado_por.nombre}}
												</p>
											</div>
										</div>
									</div>
									<div class="col-md-6 mb-3">
										<div class="media">
											<div class="align-self-center mr-3" title="Actualizado Por">
												<i class="material-icons">person_outline</i>
											</div>
											<div class="media-body">
												<label>Actualizado Por:</label>
												<p class="m-0">
													{{form.actualizado_por.codigo}} - {{form.actualizado_por.nombre}}
												</p>
											</div>
										</div>
									</div>
									<div class="col-md-6 mb-3">
										<div class="media">
											<div class="align-self-center mr-3" title="Fecha Creación">
												<i class="material-icons">access_time</i>
											</div>
											<div class="media-body">
												<label>Fecha Creación:</label>
												<p class="m-0">
													{{form.fecha_creacion}}
												</p>
											</div>
										</div>
									</div>
									<div class="col-md-6 mb-3">
										<div class="media">
											<div class="align-self-center mr-3" title="Fecha Actualización">
												<i class="material-icons">update</i>
											</div>
											<div class="media-body">
												<label>Fecha Actualización:</label>
												<p class="m-0">
													{{form.fecha_actualizacion}}
												</p>
											</div>
										</div>
									</div>
									<div class="col-md-6 mb-3">
										<div class="media">
											<div class="align-self-center mr-3" title="Creado Desde">
												<i class="material-icons">add_location</i>
											</div>
											<div class="media-body">
												<label>Creado Desde:</label>
												<p class="m-0">
													{{form.creado_desde}}
												</p>
											</div>
										</div>
									</div>
									<div class="col-md-6 mb-3">
										<div class="media">
											<div class="align-self-center mr-3" title="Actualizado Desde">
												<i class="material-icons">edit_location</i>
											</div>
											<div class="media-body">
												<label>Actualizado Desde:</label>
												<p class="m-0">
													{{form.actualizado_desde}}
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
			    	</div>
			    </div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['codigo'],

		mounted(){
			this.producto = this.codigo;
        	if(this.producto){
        		this.getProducto();
        	}
		},

		data(){
			return {
				producto: '',
				loading: false,
				form: {
					codigo: '',
					descripcion: '',
					grupo: {
						codigo: '',
						descripcion: '',
					},
					subgrupo: {
						codigo: '',
						descripcion: '',
					},
					precio: 0,

					fecha_creacion: '',
					fecha_actualizacion: '',
					creado_desde: '',
					actualizado_desde: '',
					creado_por: {
						codigo: '',
						nombre: '',
					},
					actualizado_por: {
						codigo: '',
						nombre: '',
					},
				},
			}
		},

		methods: {
			getProducto: function(){
				this.loading = true;
				var url = 'api/productos/'+this.codigo;

				axios.get(url)
				.then(response => {
					this.setData(response.data);
				}).catch(error => {
					console.log(error);
					console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			openModalConsulta: function(){
				this.getProducto();
				this.showModal();
			},

			setData: function(data){
				this.form.codigo = data.CODIGO_PRODUCTO;
				this.form.descripcion = data.DESCRIPCION_PRODUCTO;

				if (data.grupo) {
					this.form.grupo.codigo = data.grupo.CODIGO_GRUPO;
					this.form.grupo.descripcion = data.grupo.DESCRIPCION_GRUPO;
				}

				if (data.subgrupo) {
					this.form.subgrupo.codigo = data.subgrupo.CODIGO_SUBGRUPO;
					this.form.subgrupo.descripcion = data.subgrupo.DESCRIPCION_SUBGRUPO;
				}

				this.form.precio = data.PRECIO;
				
				this.form.fecha_creacion = data.FECHA_CREACION;
				this.form.fecha_actualizacion = data.FECHA_ACTUALIZACION;
				
				if (data.creado_por) {
					this.form.creado_por.codigo = data.creado_por.CODIGO_USUARIO;
					this.form.creado_por.nombre = data.creado_por.NOMBRE;
				}
				
				if (data.actualizado_por) {
					this.form.actualizado_por.codigo = data.actualizado_por.CODIGO_USUARIO;
					this.form.actualizado_por.nombre = data.actualizado_por.NOMBRE;
				}
				
				this.form.creado_desde = data.CREADO_DESDE;
				this.form.actualizado_desde = data.ACTUALIZADO_DESDE;
			},

			showModal: function(){
				$('#modalConsultaProducto').modal('show');
			},

			closeModal: function(){
				$('#modalConsultaProducto').modal('hide');
			},
		},

        watch: {
        	codigo: function(val){
        		if (val) {
        			this.producto = val;
        			this.getProducto();
        		}
        	},
  		}
	}
</script>